'use client'

import { UrlSlug } from '@repo/sanity/types'
import { cn } from '@repo/ui/lib/utils'
import { HeartIcon } from 'lucide-react'
import { FunctionComponent, MouseEventHandler, useCallback, useEffect, useState } from 'react'
import { useWishlist } from '../../../providers/WishlistProvider'
import { PageDto } from '../../../types/page.types'

interface Props {
  pageDto: PageDto
  urlSlug: UrlSlug['current']
  className?: string
}

const AddToWishlistIcon: FunctionComponent<Props> = ({ pageDto, urlSlug, className }) => {
  const { isInWishlist, handleWishlistToggle, pendingItem } = useWishlist()
  const [inWishlist, setInWishlist] = useState(false)

  useEffect(() => {
    setInWishlist(urlSlug ? isInWishlist(urlSlug) : false)
  }, [urlSlug, isInWishlist])

  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>(
    (e) => {
      e.preventDefault()
      e.stopPropagation()

      if (urlSlug) {
        handleWishlistToggle(urlSlug)
      }
    },
    [handleWishlistToggle, urlSlug],
  )

  if (!urlSlug) {
    return null
  }

  return (
    <button
      type='button'
      className={cn(
        'outline-hidden focus-visible:text-current',
        inWishlist ? 'text-miista-red-700 hover:text-current' : 'text-muted hover:text-miista-red-700',
        pendingItem === urlSlug && 'cursor-wait',
        className,
      )}
      onClick={handleClick}
      aria-label={inWishlist ? pageDto.dictionary?.wishlist?.removefromwishlist || 'Remove from Wishlist' : pageDto.dictionary?.wishlist?.addtowishlist || 'Add to Wishlist'}
      aria-busy={pendingItem === urlSlug}
      aria-live='polite'
    >
      <HeartIcon className='size-3' fill='currentColor' />
    </button>
  )
}

export default AddToWishlistIcon
